module.exports = __webpack_public_path__ + "img/end-cave.f99e0bae.png";